/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CustomerStatus {

    AWAITING_PROVIDER_RESPONSE = 'AWAITING_PROVIDER_RESPONSE',

    NEXT_PHASE_STARTED = 'NEXT_PHASE_STARTED',

    TENDER_CLOSED = 'TENDER_CLOSED'
}

